(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
      var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
  window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
     var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    const header = document.querySelector('#SiteHeader[data-sticky="true"]');
    const predictiveSearch = document.querySelector('predictive-search');
    const filterMobile = document.querySelector("#filter-mbl")
     if (st > lastScrollTop) {
       if(predictiveSearch.classList.contains("is-active")) return
     header.style.transform = "translateY(-100%)";
     if(filterMobile) filterMobile.style.top = 0 + 'px'
   } else if (st < lastScrollTop) {
     header.style.transform = "translateY(0)";
     if(filterMobile) filterMobile.style.top = header.scrollHeight + "px"
   }
     lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);

  } catch(e) { console.error(e); }
})();
})();
